import { helpers, type PluginConfiguration } from '../helpers'
import { icons } from '../icons'

export const httpAnalyzer: PluginConfiguration = {
  name: 'HTTP Analyzer',
  id: 'httpAnalyzer',
  icon: icons.httpAnalyzer,
  extra: `<label class="inline-flex items-center cursor-pointer"><input type="checkbox" value="" class="sr-only peer" id="fu-tools-http-analyzer-checkbox" onchange="window.GLOBAL_HTTP_ANALYZER.enable(this.checked)"><div class="relative w-7 h-4 bg-[#334155] rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-[#cbd5e1] after:border after:rounded-full after:w-3 after:h-3 after:transition-all peer-checked:bg-[#22d3ee]"></div></label>`,
  layout: {
    type: 'table',
    columns: [['', 'Value']],
    // @ts-expect-error Fix TypeScript type
    render: (data: { label: string; value: string | number }[]) =>
      helpers.updateTable(httpAnalyzer.id, 'rewrite', {
        rows: data.map(({ label, value }) => ({ data: [label, String(value)] })),
      }),
  },
  init: () => {
    // set default value for analyzer checkbox
    const analyzerCheckbox = document.querySelector('#fu-tools-http-analyzer-checkbox')
    if (analyzerCheckbox && 'checked' in analyzerCheckbox) {
      analyzerCheckbox.checked = localStorage.getItem('enableHttpAnalyzer') === 'true'
    }
  },
  render: (...data) => httpAnalyzer.layout.render(data),
}
